import { Component } from '@angular/core';
import { LicenseService } from '../license.service';
import { LicenseState } from '../store/license.reducers';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../authentication/authentication.service';

@Component({
    selector: 'app-license-message-dialog',
    templateUrl: './license-message-dialog.component.html',
    styleUrls: ['./license-message-dialog.component.scss']
})
export class LicenseMessageDialogComponent {
    licenseState$: Observable<LicenseState>;

    constructor(
        private readonly licenseService: LicenseService,
        private readonly authenticationService: AuthenticationService
    ) {
        this.licenseState$ = this.licenseService.getLicenseState();
    }

    public logout() {
        this.authenticationService.logout();
    }

    public activateDevice() {
        this.licenseService.activateDevice();
    }
}
